module.exports = __webpack_public_path__ + "static/media/axe.d4cb7350.svg";